exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".question-progress{list-style-type:none;padding:0}.question-progress li{display:inline-block}h2{font-size:150%;margin:0}h1 span{font-size:16px}.quiz{background-color:#fff;min-height:100px}.quiz .finished,.quiz .idle,.quiz .temporary,header{padding:20px}header{margin:10px 0;border-bottom:1px solid #ddd;position:relative}.quiz.complete .points{color:#fff;background-color:#66bb6a}.score{margin:5px}.bs-callout{padding:0}.bs-callout.complete{border-left-color:#66bb6a}fieldset.breakline{margin-bottom:0}.started .footer{height:100px;width:100%;background-color:#eee}.progress{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin-top:20px;overflow:visible}.progress .point{width:20px;height:20px;border-radius:50%;border:2px solid #c8c8c8;background-color:#fff}.progress .point.correct{background-color:#66bb6a}.progress .point.wrong{background-color:#f44336}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/game-elements/quiz/quiz.component.css
// module id = 460
// module chunks = 1